// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
visiba-document-sign {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
@media screen and (max-width: 905px) {
  visiba-document-sign {
    height: 100vh;
    width: 100vw;
  }
}
visiba-document-sign .block {
  margin-bottom: 40px;
  word-break: break-all;
}
visiba-document-sign .overlay {
  background: var(--c_mainOverlayBackground);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
visiba-document-sign .container {
  position: relative;
  pointer-events: none;
  height: 100%;
}
@media screen and (max-width: 905px) {
  visiba-document-sign .container {
    width: 100%;
  }
}
visiba-document-sign .containerInner {
  height: 100%;
}
@media screen and (max-width: 905px) {
  visiba-document-sign .containerInner {
    margin: 0 8px;
  }
}
visiba-document-sign .inner {
  background: var(--c_backgroundBox);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.4);
  padding: 46px 40px 33px;
  pointer-events: all;
  overflow-y: auto;
  max-height: 80%;
  position: relative;
  top: 100px;
  position: relative;
  border-radius: 16px;
}
@media screen and (max-width: 905px) {
  visiba-document-sign .inner {
    margin: 0 !important;
    width: 100% !important;
  }
}
visiba-document-sign .inner .title {
  font-weight: 600;
  margin-bottom: 20px;
}
visiba-document-sign .inner .summary {
  white-space: pre-line;
  word-break: break-word;
}
visiba-document-sign .inner .checkboxes {
  padding: 0 6% 40px;
}
visiba-document-sign .inner .checkboxes .wallInput {
  padding-top: 0;
  margin-top: 12px;
}
visiba-document-sign .inner h2 {
  font-size: 1.375em;
  color: var(--c_textBody);
  margin-bottom: 1.7em;
}
visiba-document-sign .inner .body {
  margin-bottom: 20px;
}
visiba-document-sign .inner .body ul {
  list-style: disc;
  padding: 0;
}
visiba-document-sign .inner .abortButton {
  margin-top: 7px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
